module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm.key,
    staticClass: "contact-page"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "contact-page-loader"
  }, [_c('loading')], 1) : _c('div', {
    staticClass: "row gutter-md"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-offset-4 col-lg-4 col-xl-4"
  }, [_c('div', {
    staticClass: "contact-info"
  }, [_c('user-image', {
    attrs: {
      "firstname": _vm.contact.firstname,
      "lastname": _vm.contact.lastname,
      "email": _vm.contact.email,
      "size": "medium"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.contact.name))]), _vm._v(" "), (!!_vm.contact.email) ? _c('p', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.contact.email))]) : _c('p', {
    staticClass: "email"
  }, [_vm._v("-")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.contact.created")) + "\n          " + _vm._s(_vm.formatDateTimeNatural(_vm.contact.created_at)) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.contact.updated")) + "\n          " + _vm._s(_vm.formatDateTimeNatural(_vm.contact.updated_at)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('div', {
    staticClass: "source-icon"
  }, [(_vm.contact.source == 'upload') ? _c('img', {
    attrs: {
      "src": require("../../../assets/icon-manual-import.svg")
    }
  }) : (_vm.contact.source == 'web_app') ? _c('img', {
    attrs: {
      "src": require("../../../assets/icon-web-app.svg")
    }
  }) : (_vm.contact.source == 'mobile_app') ? _c('img', {
    attrs: {
      "src": require("../../../assets/icon-mobile-app.svg")
    }
  }) : (_vm.contact.source == 'crm_sync') ? _c('img', {
    attrs: {
      "src": require("../../../assets/icon-crm.svg")
    }
  }) : (_vm.contact.source == 'external_form') ? _c('img', {
    attrs: {
      "src": require("../../../assets/icon-external-form.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/icon-unknown.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t("ui.contact.source")))]), _vm._v(" "), _c('p', {
    staticClass: "body-p"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("ui.contact.sources." + _vm.contact.source)) + "\n            ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "contact-details"
  }, [_c('div', {
    staticClass: "contact-details-header justify-between flex"
  }, [_c('h5', {
    staticClass: "block"
  }, [_vm._v(_vm._s(_vm.$t("ui.contact.contact_details")))]), _vm._v(" "), _c('a', {
    staticClass: "link block blue-text padding-left",
    on: {
      "click": function($event) {
        return _vm.setIsOpen(true)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.contact.edit")) + "\n          ")])]), _vm._v(" "), _vm._l((_vm.standardPersonalFields), function(entry) {
    return _c('div', {
      staticClass: "info-block"
    }, [_c('p', {
      staticClass: "caption"
    }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.contact.caption" + "." + entry.internal_name)) + "\n          ")]), _vm._v(" "), (entry.val == '') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("-")]) : (entry.internal_name == 'language') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(_vm.language) + "\n          ")]) : _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(entry.val) + "\n          ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
  }, [(_vm.contact.projects.length > 0) ? _c('div', {
    staticClass: "lead-panel"
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t("ui.contact.is_lead_on")))]), _vm._v(" "), _vm._l((_vm.contact.projects), function(project, index) {
    return _c('div', {
      key: 'lead-panel-' + project.id,
      staticClass: "project-wrapper"
    }, [_c('q-collapsible', {
      staticClass: "project-container",
      attrs: {
        "opened": index == 0
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('div', {
      staticClass: "project-title"
    }, [_c('div', {
      staticClass: "project-title-label"
    }, [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('div', {
      staticClass: "project-title-sublabel"
    }, [_vm._v("\n                  " + _vm._s(_vm.getProjectSubLabel(project)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "project-title-classification"
    }, [_c('span', {
      staticClass: "value-classification",
      class: project.classification || 'unclassified'
    }, [_vm._v(" ")]), _vm._v(" "), _c('a', {
      staticClass: "link padding-left",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.goToLead(project.id, project.lead_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("ui.contact.go_to_lead")))])])])]), _vm._v(" "), _c('div', {
      staticClass: "leadsheet-details"
    }, [(!!_vm.leadsheetTabs[project.id]) ? _c('div', {
      staticClass: "leadsheet-content"
    }, _vm._l((_vm.leadsheetTabs[project.id]), function(tab, tabName) {
      return _c('div', {
        key: tabName + project.id,
        staticClass: "leadsheet-tab-wrapper"
      }, [(tab.length > 0) ? _c('div', {
        staticClass: "leadsheet-tab"
      }, [_c('h5', [_vm._v(_vm._s(tabName))]), _vm._v(" "), _vm._l((tab), function(element) {
        return _c('span', {
          key: element.name + project.id
        }, [(element.type == 'title') ? _c('h6', {
          staticClass: "title-block"
        }, [_vm._v("\n                        " + _vm._s(element.content) + "\n                      ")]) : _c('div', {
          staticClass: "info-block"
        }, [_c('p', {
          staticClass: "caption"
        }, [_vm._v(_vm._s(element.label))]), _vm._v(" "), (
          element.type == 'quantity_selection' &&
          element.value.length > 0
        ) ? _c('p', {
          staticClass: "body-p"
        }, _vm._l((element.value), function(quantityVal) {
          return _c('span', {
            key: quantityVal.value,
            staticClass: "info-aggregate"
          }, [_c('span', {
            staticClass: "info-aggregate-label"
          }, [_vm._v(_vm._s(quantityVal.label))]), _vm._v(" "), _c('span', {
            staticClass: "info-aggregate-value"
          }, [_vm._v(_vm._s(quantityVal.value))])])
        }), 0) : (
          Array.isArray(element.value) &&
          element.value.length > 0
        ) ? _c('p', {
          staticClass: "body-p"
        }, [_vm._v("\n                          " + _vm._s(_vm.convertArrayForDisplay(element.value)) + "\n                        ")]) : (
          Array.isArray(element.value) == false &&
          !!element.value
        ) ? _c('p', {
          staticClass: "body-p"
        }, [_vm._v("\n                          " + _vm._s(element.value) + "\n                        ")]) : _c('p', {
          staticClass: "body-p"
        }, [_vm._v("-")])])])
      })], 2) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (!!_vm.tags[project.id]) ? _c('div', {
      staticClass: "info-block"
    }, [_c('p', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(_vm.$t("ui.contact.tags")))]), _vm._v(" "), (
      Array.isArray(_vm.tags[project.id]) &&
      _vm.tags[project.id].length > 0
    ) ? _c('p', {
      staticClass: "body-p"
    }, _vm._l((_vm.tags[project.id]), function(tag) {
      return _c('span', {
        key: tag.id,
        staticClass: "tag-list--item"
      }, [_vm._v(_vm._s(tag.name))])
    }), 0) : _c('p', {
      staticClass: "body-p"
    }, [_vm._v("-")])]) : _vm._e()])], 2)], 1)
  })], 2) : _c('div', [_c('empty-state', {
    attrs: {
      "name": "contacts",
      "subtitle": _vm.$t('ui.contact.empty_state_text'),
      "button": true
    }
  }), _vm._v(" "), _c('h5')], 1)]), _vm._v(" "), (_vm.company && !_vm.planIsTalent) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
  }, [_c('div', {
    key: _vm.company.id,
    staticClass: "contact-details"
  }, [_c('div', {
    staticClass: "contact-details-header justify-between flex"
  }, [_c('h5', {
    staticClass: "block"
  }, [_vm._v(_vm._s(_vm.$t("ui.contact.company_details")))]), _vm._v(" "), _c('a', {
    staticClass: "link block blue-text padding-left",
    on: {
      "click": function($event) {
        return _vm.showCompanyChange(true)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.contact.change_company")) + "\n          ")])]), _vm._v(" "), _vm._l((_vm.standardCompanyFields), function(entry) {
    return _c('div', {
      staticClass: "info-block"
    }, [(entry.display_name) ? _c('p', {
      staticClass: "caption"
    }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.company.caption" + "." + entry.internal_name)) + "\n          ")]) : _vm._e(), _vm._v(" "), (entry.val == '') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("-")]) : (entry.internal_name == 'name') ? _c('a', {
      staticClass: "link body-p",
      on: {
        "click": function($event) {
          return _vm.goToCompany(_vm.company.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(entry.val) + "\n          ")]) : (entry.internal_name == 'website') ? _c('a', {
      staticClass: "body-p",
      attrs: {
        "href": entry.val,
        "target": "_blank"
      }
    }, [_vm._v("\n            " + _vm._s(entry.val) + "\n          ")]) : (entry.internal_name == 'country') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(_vm.country) + "\n          ")]) : _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(entry.val) + "\n          ")])])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('contact-edit', {
    attrs: {
      "isOpen": _vm.isOpen,
      "contact": _vm.contact
    },
    on: {
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      },
      "save": _vm.updateContact
    }
  }), _vm._v(" "), _c('change-company', {
    attrs: {
      "isOpen": _vm.companyChangeOpen
    },
    on: {
      "cancel": function($event) {
        return _vm.showCompanyChange(false)
      },
      "save": _vm.changeCompany
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00bf8d5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contacts/Contact.vue
// module id = 1791
// module chunks = 0